/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employees_LinkLoginRequest = {
    role: employees_LinkLoginRequest.role;
};
export namespace employees_LinkLoginRequest {
    export enum role {
        ADMIN = 'admin',
        STAFF = 'staff',
    }
}

